import { Box, Button, Text } from '@optiaxiom/react';

import { styles } from './SuggestionItem.css';

type SuggestionItemProps = {
  iconBefore?: React.ReactNode;
  iconAfter?: React.ReactNode;
  label: string;
  isAction?: boolean;
  isSelected?: boolean;
  onClick?: () => void;
  onEditClick?: () => void;
};

export function SuggestionItem({
  iconBefore,
  iconAfter,
  label,
  onClick,
  isAction,
  isSelected,
  onEditClick,
}: SuggestionItemProps) {
  return (
    <Button
      w="full"
      icon={iconBefore}
      iconPosition="start"
      onClick={onClick}
      appearance="subtle"
      justifyContent="start"
      className={isSelected ? styles.suggestionItemSelected : styles.suggestionItem}
      bg={isSelected ? 'bg.default.hovered' : undefined}
      style={{ minHeight: '2rem' }}
      addonAfter={
        iconAfter ? (
          <Box
            className={styles.iconAfter}
            onClick={e => {
              e.stopPropagation();
              onEditClick?.();
            }}
          >
            {iconAfter}
          </Box>
        ) : undefined
      }
    >
      <Text color={isAction ? 'fg.secondary' : 'fg.default'} fontSize="sm" truncate>
        {label}
      </Text>
    </Button>
  );
}
